<template>
  <div id="top">

    <transition name="fade">
      <screen-saver></screen-saver>
    </transition>

    <transition name="fade">
      <router-view name="overlay" :hours="hours"></router-view>
    </transition>

    <div id="top-wrapper" class="flex flex-column">
      <div id="menu-top" class="relative flex justify-between pt2 md-pt3 px2 md-px4 z1">
        <div id="top-left" class="flex-grow">
          <router-link to="/location">224 Greene Ave (Map)</router-link>
        </div>
        <!-- <div id="top-right" class="flex-grow right-align"><router-link to="/hours" :class="getHourColor()">(Hours) {{ hours.text }}</router-link></div> -->
        <div id="top-right" class="flex-grow"><router-link to="/hours" :class="getHourColor()">See Hours</router-link></div>
      </div>

      <div v-if="programItems !== null" id="top-content" class="flex items-center">
        <carousel
          :autoplay="true"
          :perPage="1"
          :paginationEnabled="false"
          :loop="true"
          :autoplayTimeout="5000">
          <slide v-for="(programItem, index) in getFeaturedProgramItems()" :key="index">
            <div class="slide-wrapper px2 md-px2 md-px4">
              <router-link v-if="programItem.Link === '#newsletter'"
              to="/newsletter">
                <h3 v-if="typeof (programItem.Heading) !== 'undefined'" class="m0">{{ programItem.Heading }}</h3>
                <div class="program-description">{{ programItem.Description }}</div>
              </router-link>
              <a v-else-if="programItem.Link !== undefined"
                :href="programItem.Link" target="_blank">
                <h3 v-if="typeof (programItem.Heading) !== 'undefined'" class="m0">{{ programItem.Heading }}</h3>
                <div class="program-description">{{ programItem.Description }}</div>
              </a>
              <div v-else>
                <h3 v-if="typeof (programItem.Heading) !== 'undefined'" class="m0">{{ programItem.Heading }}</h3>
                <div class="program-description">{{ programItem.Description }}</div>
              </div>
            </div>
          </slide>
        </carousel>
      </div>
    </div>

    <div id="menu" class="sticky flex justify-between py2 md-py3 px2 md-px4 z1">
      <div id="bottom-left" class="flex-grow laika"><a href="#" v-scroll-to="'#top'">LAIKA</a></div>
      <div id="bottom-right" class="flex-grow">
        <scrollactive v-on:itemchanged="onItemChanged">
          <a href="#menu-items"
            v-scroll-to="{ el: '#menu-items', offset: menuHeight() }"
            class="scrollactive-item"
            :class="{active: isActive('menu')}">Menu</a>,
          <a href="#program-items"
            v-scroll-to="{ el: '#program-items', offset: menuHeight() }"
            class="scrollactive-item"
            :class="{active: isActive('program')}">Program</a>,
          <a href="#contact"
            v-scroll-to="{ el: '#contact' }"
            class="scrollactive-item"
            :class="{active: isActive('contact')}">Contact</a>,
          <a href="/booking">Booking</a>
        </scrollactive>
      </div>
    </div>

    <menu-items name="menu"></menu-items>

    <program-items v-if="programItems !== null" name="program"></program-items>

    <div class="message-box flex justify-between items-center">
      <p class="m2 md-m4 center p2 md-p4 caps">Bar Laika acknowledges that its building at 224 Greene Avenue is built on unceded Indigenous lands, specifically the territory of the Lenape. Bar Laika recognizes the continual displacement of Native people by the United States and is committed to working to dismantle the ongoing effects of this colonial legacy.</p>
    </div>

    <contact name="contact" :site-position="sitePosition"></contact>

  </div>
</template>

<script>
import {mapState} from 'vuex'
import {getHours, updateCurrentTime} from '../utils'
import ScreenSaver from './ScreenSaver'
import MenuItems from './MenuItems'
import ProgramItems from './ProgramItems'
import Contact from './Contact'
import _ from 'lodash'

export default {
  name: 'Main',
  data () {
    return {
      hours: getHours(),
      menuColorScheme: '',
      timeInterval: '',
      sitePosition: 'top'
    }
  },
  components: {
    ScreenSaver,
    MenuItems,
    ProgramItems,
    Contact
  },
  mounted () {
    this.timeInterval = setInterval(this.updateTime, 1000)
    this.adjustTopHeight()
    window.addEventListener('resize', _.debounce(() => {
      this.adjustTopHeight()
    }, 100), true)
  },
  beforeDestroy () {
    clearInterval(this.timeInterval)
  },
  computed: {
    ...mapState([
      'programItems'
    ])
  },
  methods: {
    scrollDone (el) {
      console.log(el)
    },
    adjustTopHeight () {
      document.getElementById('top-wrapper').style.height = `${window.innerHeight - document.getElementById('menu').offsetHeight}px`
    },
    menuHeight () {
      if (document.getElementById('menu') !== null) {
        return -document.getElementById('menu').offsetHeight
      } else {
        return 129
      }
    },
    getFeaturedProgramItems () {
      return this.programItems.filter(item => item.Featured === true).slice(0, 6)
    },
    isActive (item) {
      return item === this.sitePosition
    },
    updateTime () {
      updateCurrentTime()
      this.hours = getHours()
    },
    getHourColor () {
      if (this.showHours) {
        return 'white'
      } else if (this.hours.status === 'closed') {
        return 'red'
      } else {
        return 'green'
      }
    },
    onItemChanged (event, currentItem) {
      if (currentItem.getAttribute('href') === '#contact') {
        document.getElementById('menu').classList.add('yellow')
        document.getElementById('contact-bottom').classList.add('show')
        document.getElementById('contact-card').classList.add('show')
        this.sitePosition = 'contact'
      } else {
        document.getElementById('menu').classList.remove('yellow')
        document.getElementById('contact-bottom').classList.remove('show')
        document.getElementById('contact-card').classList.remove('show')
        this.sitePosition = ''
      }
    }
  }
}
</script>

<style lang="css">
  #top-wrapper {
    height: 100vh;
  }

  #top-content {
    flex-grow: 1;
    line-height: 1.25;
    a:hover {
      text-decoration: none;
    }
  }

  #menu {
    transition: background 0.2s ease-out;
    background: var(--color-black);

    a {
      transition: color 0.2s ease-out;
      color: white;
    }

    a.active, a.is-active {
      text-decoration: underline;
    }

    &.show {
      display: flex;
    }

    &.yellow {
      color: red;
      background: var(--color-yellow);
      a {
        color: red;
      }
    }
  }

  .message-box {
    font-size: var(--fs-s);
    min-height: 100vh;

    p {
      /*border: 6px solid white;*/
      color: white;
    }
  }

  #menu-top {
    a {
      &:hover {
        text-decoration: none;
        border-bottom: 0.3vw solid currentColor;
      }
    }
  }
</style>
